export default __webpack_public_path__ + "static/media/oil_can.2236cdc5.png";